import axiosApiClient from "../axios";
import {getBackendUrl} from "../../utils/config";

const PATH = '/api/stream';

export const startStream = async (cameraId) => {
    try {
        const response = await axiosApiClient.post(`${PATH}/start`, {
            cameraId: cameraId
        });
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to start stream');
    }
};

export const stopStream = async (streamId) => {
    try {
        const response = await axiosApiClient.post(`${PATH}/stop/${streamId}`);
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to stop stream');
    }
};

export const getStreamStatus = async (streamId) => {
    try {
        const response = await axiosApiClient.get(`${PATH}/status/${streamId}`);
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get stream status');
    }
};

export const getAllActiveStreams = async () => {
    try {
        const response = await axiosApiClient.get(`${PATH}/active`);
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get active streams');
    }
};

export const getStreamUrl = (streamId) => {
    const baseUrl = getBackendUrl();
    // Remove trailing slash from baseUrl if it exists
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${cleanBaseUrl}${PATH}/hls/${streamId}/playlist.m3u8`;
    console.log('Generated HLS URL:', url);
    return url;
};

export const startMJPEGStream = async (cameraId) => {
    try {
        const response = await axiosApiClient.post(`${PATH}/start/mjpeg`, {
            cameraId: cameraId
        });
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to start MJPEG stream');
    }
};

export const getMJPEGStreamUrl = (cameraId) => {
    // This function is now deprecated - use AuthenticatedStream component instead
    // which handles authentication automatically
    console.warn('getMJPEGStreamUrl is deprecated. Use AuthenticatedStream component instead.');
    const baseUrl = getBackendUrl();
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${cleanBaseUrl}/api/stream/camera-stream/${cameraId}`;
    console.log('Generated MJPEG URL (deprecated):', url);
    return url;
};

export const stopMJPEGStream = async (streamId) => {
    try {
        const response = await axiosApiClient.post(`${PATH}/stop/${streamId}`);
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to stop MJPEG stream');
    }
}; 